import React from "react";
import { Outlet } from "react-router-dom";
import SiteHeader from "@/components/layout/SiteHeader";
import SiteFooter from "@/components/layout/SiteFooter";

export default function SiteLayout() {
    return (
        <div className="relative min-h-screen flex flex-col bg-[#07070A] text-[#F2F1ED]">
            <SiteHeader />
            <main className="flex-1 relative z-10">
                <Outlet />
            </main>
            <SiteFooter />
        </div>
    );
}
